import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'arch-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './arch-loading.component.html',
  styleUrls: ['./arch-loading.component.scss'],
})
export class ArchLoadingComponent {}
